import React, {useContext, useEffect, useState} from 'react'
import {Route, withRouter} from 'react-router-dom'
import SidebarNavList from './sidebar_nav_list.jsx'
import Menu from '../../config/page_route'
import {observer} from 'mobx-react'
import {rootStore} from '../../mobx/store'
import {Page_settings} from '../../config/page_settings'

const Sidebar_nav = observer((props) => {
  const context = useContext(Page_settings)
  let [active, setActive] = useState(-1)
  let [clicked, setClicked] = useState(-1)
  let [menu, setMenu] = useState(Menu)

  useEffect(() => {
    let menu1 = JSON.parse(JSON.stringify(Menu))
    // if (context.showChat === 'OFF') {
    //   menu1 = menu1.filter(function (item) {
    //     return item.index !== 0
    //   })
    // }
    if (!rootStore.isSignedIn || rootStore.getMe.mb_lv <= 1) {
      menu1 = menu1.filter(function (item) {
        return item.index !== 3
      })
    }
    menu1 = menu1.filter(function (item) {
      return (item.index !== 4)
    })
    setMenu(menu1)
  }, [])

  const handleExpand = (e, i, match) => {
    e.preventDefault()

    if (clicked === -1 && match) {
      setActive(-1)
      setClicked(1)
    } else {
      setActive(active === i ? -1 : i)
      setClicked(1)
    }
  }

  return (
    <ul className='nav'>
      {menu.map((menu, i) => (
        <Route path={menu.path} exact={menu.exact} key={i} children={({ match }) => (
          <SidebarNavList
            data={menu}
            key={i}
            expand={(e) => handleExpand(e, i, match)}
            active={i == active}
            clicked={clicked}
          />
        )} />
      ))}
    </ul>
  )
})

export default withRouter(Sidebar_nav)
